import { chartConfig } from "../chart.commonConfig";
import { PATHS, PDF_CONSTANT } from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";

export const FIRST_PIE_CHART_RESPONSIVE_HELPER = (
  data,
  history,
  checkedValue
) => {
  const PieChartConfig = {
    chart: {
      ...chartConfig.chart,
      type: "pie",
      className: "chart-background first-pie-graph",
      spacingBottom: 0,
      height: (12 / 16) * 100 + "%",
      animation: {
        duration: 9000
      },
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.SECOND_PAGE.FIRST._SUCCESS
          });
        }
      }
    },
    title: {
      ...chartConfig.title,
      align: "center",
      text: "",
      useHTML: true,
      verticalAlign: "middle",
      y: 10,
      style: { color: "#000000", fontSize: "26px", "font-family": "mpb" }
    },
    plotOptions: {
      series: {
        animation: true
      },
      pie: {
        showInLegend: false,
        shadow: true,
        cursor: "pointer",
        allowPointSelect: true,
        point: {
          events: {
            legendItemClick: function() {
              this.slice(null);
              return false;
            },
            click: function(event) {
              history.push({
                pathname: PATHS.PROJECT_LIST,
                isDashBoard: true,
                summaryDataBy: false,
                state: {
                  groupCategory: "CENTRAL",
                  projectStage: [
                    {
                      displayName: "VERIFIED",
                      key: "VERIFIED"
                    }
                  ],
                  projectFlags: checkedValue
                    ? [
                        {
                          displayName: "MARCH 24",
                          key: "MARCH 24"
                        }
                      ]
                    : null,
                  projectImplementationMode: [
                    {
                      displayName: this.name,
                      key: this.name
                    }
                  ]
                }
              });
            }
          }
        }
      }
    },
    series: [
      {
        type: "pie",
        name: "Issues",
        data: [],
        size: "90%",
        innerSize: "50%",
        dataLabels: {
          enabled: true,
          alignTo: "connectors",
          color: "white",
          className: "data-label-text",
          style: {
            color: "black"
          },
          distance: -30,
          format: `<span style="color:{point.color}">{point.y}</span>`
        }
      }
    ],
    legend: {
      enabled: true,
      verticalAlign: "bottom"
    },
    tooltip: {
      formatter: function() {
        return `
                <b>${this.key}</b><br />
                <b>Projects: ${this.y}</b>
              `;
      }
    }
  };

  try {
    // set data
    const {
      projectImplementationModeCountDTOList: list = [],
      totalActiveProjects = 0
    } = data;
    PieChartConfig.series[0]["data"] = list.map((val, index) => {
      return { name: val.implementationMode, y: val.count };
    });
    //PieChartConfig.title.text = `UNDER CONSTRUCTION / UNDER IMPLEMENTATION : ${totalActiveProjects} PROJECTS`;
    PieChartConfig.title.text = `${totalActiveProjects}`;
    //PieChartConfig.subtitle.text = `Implementation mode within ${totalActiveProjects} PMG monitored projects`;
    //PieChartConfig.subtitle.text = `TOTAL PROJECTS`;
    return PieChartConfig;
  } catch (error) {
    console.error(error);
  }
};
